import useRemoveAccepted from '@/api/mutations/proposals/useRemoveAccepted';
import ProposalConfirmationModal from '@/ui/pages/proposalBuilderPage/components/proposalLifecycleActions/ProposalConfirmationModal';
import { ModalProps, Text, useToastContext } from '@payaca/ambrosia';
import { FC } from 'react';

type RemoveProposalAcceptanceModalProps = {
  /** The route param public id, used to invalidate the Proposal's cache. */
  proposalId: string;
  /** The Proposal's numeric id. Absent until the Proposal query resolves. */
  numericProposalId: string | undefined;
  projectId: string;
} & Omit<ModalProps, 'title'>;

const RemoveProposalAcceptanceModal: FC<RemoveProposalAcceptanceModalProps> = (
  props
) => {
  const { proposalId, numericProposalId, projectId, onClose, ...rest } = props;
  const { pushSuccess } = useToastContext();

  const { mutate, isPending } = useRemoveAccepted({
    proposalId,
    projectId,
    options: {
      onSuccess: () => {
        pushSuccess('Acceptance removed.');
        onClose?.();
      },
    },
  });

  return (
    <ProposalConfirmationModal
      {...rest}
      onClose={onClose}
      title="Remove acceptance"
      confirmLabel="Remove signature"
      confirmColour="negative"
      isPending={isPending}
      onConfirm={() =>
        numericProposalId && mutate({ proposalId: numericProposalId })
      }
    >
      <Text>
        This returns the proposal to sent and removes the customer&apos;s
        signature. Removing the signature can&apos;t be undone. If they accept
        again, they will need to re-sign.
      </Text>
    </ProposalConfirmationModal>
  );
};

export default RemoveProposalAcceptanceModal;
